import useAppQuery from 'hooks/useAppQuery';
import useAppUser from 'hooks/useAppUser';
import { GetAgencyDbsConfigResponseTO } from 'models/AgencyDbs';
import API from 'services/API';

export const AGENCY_DBS_CONFIG_BASE_QUERY_KEY = 'agencyDbsConfig';

export const getAgencyDbsConfigUrl = (agencyUid: string) =>
  `/api/v3.2/dbs/agencies/${agencyUid}`;

const useFetchAgencyDbsConfig = () => {
  const { agencyUid } = useAppUser();

  const { data, isInitialLoading, isError } = useAppQuery(
    [AGENCY_DBS_CONFIG_BASE_QUERY_KEY, agencyUid],
    async () => {
      const response = await API.get<GetAgencyDbsConfigResponseTO>(
        getAgencyDbsConfigUrl(agencyUid!),
      );

      return response.data;
    },
    { enabled: !!agencyUid },
  );

  return {
    agencyDbsConfig: data?.dbs,
    isLoading: isInitialLoading,
    isError,
  };
};

export default useFetchAgencyDbsConfig;
